__turbopack_context__.v({
  "arrow": "styles-module-scss-module__r9NNYq__arrow",
  "content": "styles-module-scss-module__r9NNYq__content",
  "root": "styles-module-scss-module__r9NNYq__root",
  "rootIsOpened": "styles-module-scss-module__r9NNYq__rootIsOpened",
  "title": "styles-module-scss-module__r9NNYq__title",
  "titleBlock": "styles-module-scss-module__r9NNYq__titleBlock",
});
